import { FC, ReactNode } from 'react';
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import { FormatListBulleted, Image as ImageIcon, Topic } from '@mui/icons-material';

export type AiMethod = 'wordlist' | 'topic' | 'image';

interface Props {
    onSelect: (method: AiMethod) => void;
}

const items: Array<{
    method: AiMethod;
    title: string;
    description: string;
    example: string;
    icon: ReactNode;
}> = [
    {
        method: 'wordlist',
        title: '단어목록',
        description: '직접 입력한 단어 목록의 뜻을 AI가 생성합니다.',
        example: '예: apple, banana, cherry',
        icon: <FormatListBulleted fontSize="large" />,
    },
    {
        method: 'topic',
        title: '주제',
        description: '주제를 입력하면 AI가 관련 단어 N개를 생성합니다.',
        example: '예: airport, business meeting',
        icon: <Topic fontSize="large" />,
    },
    {
        method: 'image',
        title: '이미지',
        description: '단어가 적힌 이미지에서 단어를 추출하고 뜻을 생성합니다.',
        example: '예: 사진, 스캔본, 스크린샷',
        icon: <ImageIcon fontSize="large" />,
    },
];

export const StepMethodSelect: FC<Props> = ({ onSelect }) => {
    return (
        <Stack spacing={2} sx={{ pt: 1 }}>
            {items.map((item) => (
                <Card key={item.method} variant="outlined">
                    <CardActionArea onClick={() => onSelect(item.method)}>
                        <CardContent>
                            <Box display="flex" gap={2} alignItems="flex-start">
                                <Box color="primary.main">{item.icon}</Box>
                                <Box flex={1}>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {item.description}
                                    </Typography>
                                    <Typography variant="caption" color="text.disabled">
                                        {item.example}
                                    </Typography>
                                </Box>
                            </Box>
                        </CardContent>
                    </CardActionArea>
                </Card>
            ))}
        </Stack>
    );
};
